export const interviewLocalStorageKey = (vacancyId: string) =>
  `current-interview-${vacancyId}`
